import { faUsd } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { ifNaN, roundToNearestCent, toDecimalString } from "Tools";
import { hasValue } from "Tools";
import { SimpleFieldProps, withFieldValueConverter } from "./FormTools";
import { Textbox, TextboxProps } from "./Textbox";
import { YupDefined } from "./Tools";

interface NumberInputProps extends Omit<Partial<TextboxProps>, "field"> {
  field: SimpleFieldProps<number | null>;
  integerScale?: number;
  numeralPositiveOnly?: boolean;
}

export function DollarsAndCentsInput({
  field,
  integerScale = 12,
  numeralPositiveOnly = true,
  ...props
}: NumberInputProps) {
  return (
    <Textbox
      fieldProps={withFieldValueConverter(field, {
        parse: e =>
          hasValue(e) ? ifNaN(roundToNearestCent(parseFloat(e)), null) : null,
        format: e => (hasValue(e) ? toDecimalString(e, 2) : null),
      })}
      placeholder={props.placeholder}
      cleaveOptions={{
        numeral: true,
        numeralThousandsGroupStyle: "thousand",
        numeralPositiveOnly,
        numeralIntegerScale: integerScale,
      }}
      leftIconContent={<FontAwesomeIcon icon={faUsd} />}
      style={{ minWidth: "19em" }}
      {...props}
    />
  );
}

DollarsAndCentsInput.getDefaultValidator = () => YupDefined.number().nullable();
